import { useTranslation } from "react-i18next";

const SecondSection = () => {
  const { t } = useTranslation();

  return (
    <div className="about__second-section d-flex flex-column">
      <p className="text--white fsize--4 fw--500 mb-0">{t("about.secondSection.1")}</p>
      <p className="text--white fsize--4 fw--500 mb-0">{t("about.secondSection.2")} </p>
    </div>
  );
};

export default SecondSection;
